export const blockIconsSocialCompostNew = (
	<span className='material-symbols-outlined'>compost</span>
);
